import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserserviceService } from 'src/hp-app/services/userservice.service';
import { Address } from 'src/hp-app/models/address';
import { ProductDocument } from 'src/hp-app/models/productdocument';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {

  orderId: string;
  shippingAddress: Address = new Address();
  selectedDocumentList: ProductDocument[] = [];
  orderdetails: any = {};
  isdisplay = false;
  direction: string = "ltr";

  constructor(private route: ActivatedRoute, private _http: UserserviceService, private translate: TranslateService,private messageService:MessageService) {
    this.orderId = this.route.snapshot.params["id"];
    let language = this._http.getGlobalLanguage();
    translate.use(language);
    if (language.toLowerCase() == 'ar') {
      this.direction = "rtl";
    }
  }

  ngOnInit() {
    if (this.orderId != null) {
      this.getOrderedProducts(this.orderId);
    }
  }

  /**
   *  @description Method to get OrderDetails i.e OrderId,Orderdate
   *  @author HariKiran 
   * @date 10/10/2019 
   *  @memberof OrderSummaryComponent 
   * */
  getOrderDetails(orderId) {
    this._http.getOrderDetails(orderId).subscribe(
      data => { this.orderdetails = data },
       err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }


  /**
  *  @description Method to get Ordered Products
  *  @author HariKiran 
  * @date 10/10/2019 
  *  @memberof OrderSummaryComponent 
  * */
  getOrderedProducts(orderId) {
    this._http.getOrderedProducts(orderId).subscribe(
      data => {
        this.selectedDocumentList = data;
        if (this.selectedDocumentList.length > 0) {
          this.isdisplay = true;
          this.getOrderDetails(this.orderId);
        } else {
          this.isdisplay = false;
        }
      },
      err => {
        this.messageService.add({severity:'error', summary: 'Error Message', detail: err.message});
      }
    )
  }

}
